export default {
  LOAD_LIST_REGISTRATION_TYPE(state, data) {
    state.listRegistrationsTypes = data
  },
  PREPARE_TO_EDIT_REGISTRATION_TYPE(state, data) {
    state.registrationType = data
  },
  RESET_REGISTRATION_TYPE(state) {
    state.registrationType = {
      nome: '',
      valor: '',
      ativo: true,
      tipo: null,
      tiposFaixaPadrao: [],
      tipoPagamentoPadrao: null,
      contaPadrao: null,
    }
  },
  SET_LIST_COMBO_TYPE(state, data) {
    state.comboTypes = data.map(item => ({
      id: item.id,
      nome: item.nome,
    }))
  },
  SET_COMBO_TIPO_FAIXA(state, data) {
    state.comboTipoFaixa = data
  },
  SET_COMBO_TIPO_PAGAMENTO(state, data) {
    state.comboTipoPagamento = data
  },
  SET_COMBO_CONTAS(state, data) {
    state.comboContas = data
  },
}
